import { getAssetUrl } from '@lighthouse/assets'
import React from 'react'

export const guideTaskList: {
    id: string
    image: string
    title: string
    steps: { id: string; title: string; source?: string; describe: React.ReactNode }[]
}[] = [
    {
        id: 'creatGallery',
        title: '如何使用画廊视图搭建一个团队名片？',
        image: getAssetUrl('guide', 'task_create_gallery.jpg'),
        steps: [
            {
                id: 'createDatSource',
                title: '数据源：创建数据表',
                source: 'https://www.bilibili.com/video/BV1NMAzeQEB3/?spm_id_from=333.1387.homepage.video_card.click&vd_source=33bf6aee0a14321290af0557d4c12ee0',
                describe: (
                    <div>
                        在数据中创建一个数据表，在新创建的数据表中，添加名片的相关字段，例如：姓名（文本格式）、电话（电话格式）、职位（文本格式）以及头像（附件格式）。数据表将存放团队成员的相关信息。
                    </div>
                )
            },
            {
                id: 'createTeamCard',
                title: '创建团队名片首页',
                source: 'https://www.bilibili.com/video/BV1NMAzeQEB3?spm_id_from=333.788.videopod.episodes&vd_source=33bf6aee0a14321290af0557d4c12ee0&p=2',
                describe: (
                    <div>
                        在左侧的【添加】栏中，从组件库选择【视图画廊】组件，将选中的视图画廊拖拽到界面中。然后在右侧的【配置】栏中，找到并选择“绑定数据源”选项，将之前创建并已填充数据的数据表与视图画廊组件绑定。我们可以在右侧的【设计】栏中，根据设计需求调整首页名片的样式，设计合适的卡片内容排版，以展现你想呈现的信息。
                    </div>
                )
            },
            {
                id: 'configViewDetailPage',
                title: '配置视图打开详情页的动作',
                source: 'https://www.bilibili.com/video/BV1NMAzeQEB3?spm_id_from=333.788.videopod.episodes&vd_source=33bf6aee0a14321290af0557d4c12ee0&p=3',
                describe: (
                    <div>
                        展开视图的详情页需要选中画廊组件，在右侧的属性栏中，找到并点击【交互】选项，找到【展开记录】功能，开启展开记录选择或创建一个新的记录页面，用于展示详细信息。
                    </div>
                )
            },
            {
                id: 'designDetailPage',
                title: '设计详情页排版与插入变量',
                source: 'https://www.bilibili.com/video/BV1NMAzeQEB3?spm_id_from=333.788.videopod.episodes&vd_source=33bf6aee0a14321290af0557d4c12ee0&p=4',
                describe: (
                    <div>
                        在设计一个页面的时候，容器是必不可少的，在页面中拖入一个容器组件，如行容器或列容器，用于组织页面内容。我们可以在容器中拖入任意组件用于展现相关信息。例如图片组件：用于展示头像或其他相关图片。文本组件：用于输入和展示姓名、职位等信息。按钮组件：跳转其他功能或页面等等。同时我们可以在文本输入框中有一个「➕」按钮，点击后可以添加绑定数据表的相应字段，用于呈现变量信息。
                    </div>
                )
            },
            {
                id: 'updateMobileConfig',
                title: '调整移动端适配',
                source: 'https://www.bilibili.com/video/BV1NMAzeQEB3?spm_id_from=333.788.videopod.episodes&vd_source=33bf6aee0a14321290af0557d4c12ee0&p=5',
                describe: (
                    <div>
                        将模拟器调整为移动端，在移动端统一调整宽度尺寸不会影响到电脑端的尺寸。如果调整错误可以重置调整，快捷键撤销：在Windows系统中，可以通过快捷键Ctrl
                        + Z来撤销上一步操作。在Mac系统中，对应的快捷键是Command + Z。
                    </div>
                )
            },
            {
                id: 'preview',
                title: '预览',
                source: getAssetUrl('guide', 'task_preview.jpg'),
                describe: <div>点击预览可以直接查看你制作好的样式，任何编辑操作，在预览中点击刷新就可以查看。</div>
            },
            {
                id: 'publish',
                title: '发布分享',
                source: getAssetUrl('guide', 'task_publish.jpg'),
                describe: '制作完成后，我们可以选择发布应用，这样我们的应用就成功上线，分享给你的好友吧。'
            }
        ]
    },
    {
        id: 'creatContainer',
        title: '如何使用容器组件设计网站？',
        image: getAssetUrl('guide', 'task_create_container.jpg'),
        steps: [
            {
                id: 'websiteContent',
                title: '区分网站板块内容',
                source: getAssetUrl('guide', 'task_website.jpg'),
                describe:
                    '我们会将整个网站页面分解成不同的板块内容，并构思每个板块的结构组成。以ByeCode官网为例，我们详细标注了构成每个板块的各个组件，这样就可以快速理解如何利用ByeCode的组件化工具来搭建一个完整的网站。'
            },
            {
                id: 'makeWebsite',
                title: '开始制作',
                source: 'https://www.bilibili.com/video/BV1j4AzezE4W/?spm_id_from=333.1387.homepage.video_card.click&vd_source=33bf6aee0a14321290af0557d4c12ee0',
                describe:
                    '我们随机选择一个官网案例，然后使用ByeCode平台来逐步复现它。为了让您更详细地了解整个过程，我们提供了一个视频教程，其中包含了从布局设置、组件添加和设计调整，到两端适配等所有必要的步骤。这个视频将帮助您掌握如何将设计理念转化为实际的网站构建'
            }
        ]
    }
]
